import Link from 'next/link';
import React from 'react';

import ROUTES from '../../../routes';
import { ContentContainer } from '../../landing/contentComponents';
import { SectionContainer } from '../../landing/sectionComponents';

import ToggleItem from './ToggleItem';

import Heading from '@components/Heading';

const faqs = [
  {
    question: 'Why choose PopSQL?',
    answer: (
      <>
        PopSQL saves your team time and lets them move faster. Learn more in our{' '}
        <Link href={ROUTES.sqlEditorBuyersGuide}>
          <a className="focus:outline-none focus:opacity-80">
            SQL Editor Buyer's Guide
          </a>
        </Link>
        .
      </>
    ),
  },
  {
    question: 'What is an editor, and how is it different than a viewer?',
    answer:
      'Editors are members of your team that can create, edit, and execute queries. Viewers can only view the queries you share with them. We only bill you for editors.',
  },
  {
    question:
      'What happens when people join or leave my team? How will we be charged?',
    answer:
      "We will pro rate the difference. So if someone leaves in the middle of the month, we'll add a credit for half a month on your next bill. And if someone joins in the middle of the month, we'll only bill you for the half month.",
  },
  {
    question: 'Any special deals for students?',
    answer: (
      <>
        Yes, Business accounts are available for free for students enrolled in
        the{' '}
        <Link href={ROUTES.gitHubStudents}>
          <a className="focus:outline-none focus:opacity-80">
            GitHub Student Developer Pack
          </a>
        </Link>
        .
      </>
    ),
  },
];

const FaqsSection = ({ content = faqs, defaultOpen = true }) => (
  <SectionContainer>
    <Heading Tag="h2" size="sm">
      {' '}
      Frequently Asked Questions
    </Heading>
    <ContentContainer>
      <div className="max-w-3xl border-b font-inter border-gray-100 mx-auto">
        {content.map((item, index) => (
          <ToggleItem
            defaultOpen={defaultOpen}
            key={`${item.question}-${index}`}
            item={item}
          />
        ))}
      </div>
    </ContentContainer>
  </SectionContainer>
);

export default FaqsSection;
